import { ChatCategory, type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { useContactsContext } from '@/contexts/contacts/context';
import type { CreateContactParams } from '@/contexts/contacts/types';
import styles from './index.module.scss';
import BlockIcon from './images/block.svg?react';
import AddIcon from './images/add.svg?react';
import NewContactModal from './components/addModal';

export interface ChatProps {
  chat: Chat;
}

const AddFriend = ({ chat }: ChatProps) => {
  const [open, setOpen] = useState(false);
  const { contacts, addContacts } = useContactsContext();

  const isFriend = useMemo(
    () => contacts.find((contact) => contact.user_id === chat.user.userId),
    [chat.user.userId, contacts]
  );

  const isGroup = useMemo(() => chat.category === ChatCategory.GROUP, [chat.category]);

  const addContactClick = useCallback(async () => {
    const { user } = chat;
    const params: CreateContactParams = {
      chat_id: chat.chat_id,
      id: 0,
      category: 0,
      user_id: user.userId,
      state_msg: '',
      name: user.name || '',
      // TODO: username
      username: user.username || '',
      avatar: user.avatar!,
      remark_name: '',
      verified: 0,
      dnd: 0,
      org_id: 0,
      org_name: '',
      external: 0,
      role: 0,
      create_at: user.createdAt!,
      update_at: user.updatedAt!,
    };
    await addContacts([params]);
    setOpen(false);
    // message.success('Contact request sent successfully');
  }, [addContacts, chat, setOpen]);

  if (isFriend || isGroup) {
    return null;
  }

  return (
    <>
      <div className={styles.addFriend}>
        <div className={styles.block} onClick={() => message.info('Coming soon.')}>
          <BlockIcon />
          Block
        </div>
        <div
          className={styles.add}
          onClick={() => {
            // setOpen(true)
            addContactClick();
          }}
        >
          <AddIcon />
          Add Contacts
        </div>
      </div>
      <NewContactModal chat={chat} open={open} setOpen={setOpen}></NewContactModal>
    </>
  );
};
export default AddFriend;
